var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { attrs: { "data-qa": "price_club" } }, [
    _c("div", { staticClass: "d-flex align-center gc-3" }, [
      _c(
        "div",
        {
          staticClass: "text-h6 error--text d-flex align-center gc-1 mb-1",
          attrs: { "data-qa": "price_club_num" },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_setup.getFormattedPrice(_vm.clubPrice)) +
              "\n      "
          ),
          _c("img", {
            attrs: {
              alt: _setup.t("Иконка Процент Клуба", _setup.options),
              src: "/static/_v1/pd/icons/ui-kit/club/club-percent.svg",
              width: "20",
              height: "20",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "text-body-2 text-secondary--text text-decoration-line-through mb-1",
          attrs: { "data-qa": "price_club_orig_num" },
        },
        [
          _vm._v(
            "\n      " + _vm._s(_setup.getFormattedPrice(_vm.price)) + "\n    "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex align-center gc-3" }, [
      _c(
        "div",
        {
          staticClass: "text-caption error--text",
          attrs: { "data-qa": "price_club_desc" },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_setup.t("Клубная цена", _setup.options)) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "text-caption text-secondary--text d-flex align-start cursor-pointer pa-1 ma-n1",
          attrs: { "data-qa": "price_club_more" },
          on: {
            click: function ($event) {
              return _vm.$emit("click:show-info")
            },
          },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_setup.t("Подробнее о цене", _setup.options)) +
              "\n      "
          ),
          _c("div", {
            staticClass:
              "ui-icon-arrow-right ui-icon-fz-smaller icon-secondary--text",
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }